package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksInvoiceDto(
    val Invoice: QuickbooksInvoice,
    val time: String,
)

@Serializable
data class QuickbooksInvoice(
    val TxnDate: String? = null,
    val TotalAmt: Double? = null,
    val Line: List<Line>? = null,
    val DueDate: String,
    val DocNumber: String,
    val SyncToken: String,
    val Balance: Double,
    val CustomerRef: CustomerRef,
    val Id: String,
)

@Serializable
data class Line(
    val Description: String? = null,
    val DetailType: String,
    val SalesItemLineDetail: SalesItemLineDetail? = null,
    val LineNum: Int? = null,
    val Amount: Double? = null,
    val Id: String? = null,
    val SubTotalLineDetail: SubTotalLineDetail? = null,
)

@Serializable
data class SalesItemLineDetail(
    val ServiceDate: String? = null,
    val ItemRef: ItemRef,
    val Qty: Int? = null,
    val UnitPrice: Double? = null,
)

@Serializable
data class TaxCodeRef(
    val value: String,
)

@Serializable
data class ItemRef(
    val name: String,
    val value: String,
)

@Serializable
data class SubTotalLineDetail(
    val SubTotalLineDetail: String? = null,
)

@Serializable
data class CustomerRef(
    val name: String,
    val value: String,
)